document.addEventListener('DOMContentLoaded', () => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const reveals = document.querySelectorAll('.merchant-help-section .motion-reveal');

  if (reducedMotion) {
    reveals.forEach((el) => el.classList.add('is-visible'));
  } else if (reveals.length) {
    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    reveals.forEach((el) => observer.observe(el));
  }

  document.querySelectorAll('.faq-question').forEach((button) => {
    button.addEventListener('click', () => {
      const item = button.closest('.faq-item');
      const answer = item.querySelector('.faq-answer');
      const isOpen = button.getAttribute('aria-expanded') === 'true';

      if (isOpen) {
        button.setAttribute('aria-expanded', 'false');
        answer.style.height = `${answer.scrollHeight}px`;
        requestAnimationFrame(() => {
          answer.style.height = '0px';
        });
        item.classList.remove('is-open');
        window.setTimeout(() => {
          answer.hidden = true;
        }, 280);
      } else {
        button.setAttribute('aria-expanded', 'true');
        answer.hidden = false;
        answer.style.height = '0px';
        requestAnimationFrame(() => {
          answer.style.height = `${answer.scrollHeight}px`;
        });
        item.classList.add('is-open');

        const tidyUp = () => {
          answer.style.height = 'auto';
          answer.removeEventListener('transitionend', tidyUp);
        };

        answer.addEventListener('transitionend', tidyUp);
      }
    });
  });
});
